import { Theme } from '@material-ui/core';
import { styled } from '@material-ui/core';
import React, { FC } from 'react';
import { SpriteIconsSolid } from 'src/config/api/models/FontAwesome';
import theme from 'src/config/theme';
import { FontAwesomeSpriteIcon } from 'src/modules/shared/components/FontAwesomeLocal';

type PreferredVersionSelectorProps = {
  selected: boolean;
  onClick: () => void;
  withIcon?: boolean;
  isDefault?: boolean;
  tooltip?: string;
};



const CustomTooltip = styled('div')<Theme>(({ theme }) => ({
  transform: 'translate(-100%, 0)',
  position: 'absolute',
  minHeight: '1.5rem',
  minWidth: '120px',
  border: `1px solid ${theme.palette.grey.A700}`,
  padding: '0.5rem',
  borderRadius: theme.config.defaultBorderRadius,
  background: theme.palette.grey.A700,
  color: theme.palette.common.white,
  display: 'none',
  fontSize: '10px',
  opacity: 0.8,
  '&.is-open': {
    display: 'inline',
  },
}));

const Div = styled('div')<Theme>(({ theme }) => ({
  width: '18px',
  height: '18px',
  borderRadius: '50%',
  border: '1px solid #F3F1EC',
  flex: 'none',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  cursor: 'pointer',
  '&:hover': {
    borderColor: theme.palette.grey['400'],
  },
  '&.selected': {
    border: `1px solid ${theme.palette.primary.main}`,
  },
}));

export const PreferredDifferentiationSelector: FC<PreferredVersionSelectorProps> = ({
  selected,
  onClick,
  withIcon,
  isDefault,
  tooltip,
}) => {
  const [isOpen, setIsOpen] = React.useState(false);
  return (
    <>
     {/*  <Wrapper
        onMouseEnter={() => setIsOpen(true)}
        onMouseLeave={() => setIsOpen(false)}
        onClick={onClick}
        className={selected ? 'selected' : ''}
        >
        
        {selected && indicator}
      </Wrapper> */}
      <Div 
        onMouseEnter={() => setIsOpen(true)}
        onMouseLeave={() => setIsOpen(false)}
        onClick={onClick}
        className={selected ? 'selected' : ''}
      >
        {selected && <FontAwesomeSpriteIcon
          style={{ width : 'unset', height: '10px' }}
          icon={SpriteIconsSolid.CHECK}
          iconSize="xs"
          color={theme.palette.primary.main}
        />}
        <CustomTooltip className={isOpen ? 'is-open' : ''}>
          {selected ? 'Deze versie opent standaard voor jou.' : tooltip}
        </CustomTooltip>
      </Div>
    </>
  );
};
